import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = 'Points';

const slice = createSlice({
  name: '$loyaltyPointsName',
  initialState,
  reducers: {
    setLoyaltyPointsName(state, action: PayloadAction<string>) {
      return action.payload;
    },
  },
});

export const { setLoyaltyPointsName } = slice.actions;
export default slice.reducer;
